<template>
  <div>
    <ConfirmModal
      :is-open="deleteEntryDialog"
      :confirm-header-text="isDisabled ? $nt('enableHeader') : $nt('disableHeader')"
      :confirm-body-text="isDisabled ? $nt('enableBody') : $nt('disableBody')"
      :confirm-button-color="isDisabled ? 'green' : 'red'"
      :confirm-button-text="isDisabled ? $nt('enable') : $nt('disable')"
      @confirm="toggleAgency"
      @dialogToggle="val => deleteEntryDialog = val"
    />

    <VCard>
      <VCardTitle>
        <span class="headline">
          {{ $nt('headline') }}
        </span>
      </VCardTitle>
      <VCardText>
        <p v-if="isDisabled">
          {{ $nt('enableUserWarn') }}
        </p>
        <p v-else>
          {{ $nt('disableUserWarn') }}
        </p>
      </VCardText>
      <VCardActions>
        <VSpacer />
        <VBtn
          :color="isDisabled ? 'primary' : 'error'"
          flat
          @click.native="deleteEntryDialog = true"
        >
          <span v-if="isDisabled">
            {{ $nt('enableButton') }}
          </span>
          <span v-else>
            {{ $nt('disableButton') }}
          </span>
        </VBtn>
      </VCardActions>
    </VCard>
  </div>
</template>

<script>
import ConfirmModal from '../../../global-components/confirmModal/ConfirmModal'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'AgencyDisable',
  components: { ConfirmModal },
  props: ['agencyId'],
  data () {
    return {
      deleteEntryDialog: false
    }
  },
  computed: {
    ...mapGetters('agency', ['currentAgency']),
    isDisabled () {
      return this.currentAgency.status.name === 'blocked'
    }
  },
  methods: {
    ...mapActions('agency', ['disableAgency', 'enableAgency']),
    async toggleAgency () {
      if (this.isDisabled) {
        try {
          this.$notification(await this.enableAgency({ agency: this.currentAgency }))
          this.deleteEntryDialog = false
        } catch (e) {
          this.$notification(e)
        }
      } else {
        try {
          this.$notification(await this.disableAgency({ agency: this.currentAgency }))
          this.deleteEntryDialog = false
        } catch (e) {
          this.$notification(e)
        }
      }
    }
  }
}
</script>
